export const getSetupIntent = (state) => state.payment.stripe.setupIntent;
